module.exports = __webpack_public_path__ + "assets/img/Fotolia_145071668_XS.27b7abd0.jpg";